<template>
  <div class="Interview_notice">
    <el-form :inline="true" :model="formInline" class="demo-form-inline" style="">
      <el-form-item label="综合查询">
        <el-input v-model="formInline.UserInfo" placeholder="综合查询"></el-input>
      </el-form-item>
      <el-form-item label="选择日期">
        <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" value-format="yyyy-MM-dd" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="短信类型">
        <el-select v-model="formInline.SourceFlg" placeholder="请选择短信类型">
          <el-option label="短信验证码" value="0"></el-option>
          <el-option label="访谈预约开始提前1天提醒" value="1"></el-option>
          <el-option label="访谈候补超过24小时取消提醒" value="2"></el-option>
          <el-option label="访谈预约成功提醒" value="3"></el-option>
          <el-option label="咨询候补失败提前1小时通知" value="4"></el-option>
          <el-option label="心理咨询提前一天短信提醒" value="5"></el-option>
          <el-option label="长咨询最后2次时短信提醒" value="6"></el-option>
          <el-option label="通知需要咨询的学员" value="7"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="来源单号">
        <el-input v-model="formInline.SourceNo" placeholder="来源单号"></el-input>
      </el-form-item>
      <el-form-item label="短信内容">
        <el-input v-model="formInline.Content" placeholder="短信内容"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="nav">
      <el-button style="margin-left:14px;margin-top:10px;margin-bottom:10px" type="primary" @click="del()">选中删除</el-button>
      <el-table :data="tableData" style="width: 98%;margin-left:1%;" @selection-change="handleFourthSelection" :row-key="(row) => {return row.alertKey; }">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="userID" label="学生学号" width="180"></el-table-column>
        <el-table-column prop="talkType" label="短信类型" width="180"></el-table-column>
        <el-table-column label="短信类型">
          <template slot-scope="scope">
            <span v-if="scope.row.talkType == 0">短信验证码</span>
            <span v-else-if="scope.row.talkType == 1">访谈预约开始提前1天提醒</span>
            <span v-else-if="scope.row.talkType == 2">访谈候补超过24小时取消提醒</span>
            <span v-else-if="scope.row.talkType == 3">访谈预约成功提醒</span>
            <span v-else-if="scope.row.talkType == 4">咨询候补失败提前1小时通知</span>
            <span v-else-if="scope.row.talkType == 5">心理咨询提前一天短信提醒</span>
            <span v-else-if="scope.row.talkType == 6">长咨询最后2次时短信提醒</span>
            <span v-else-if="scope.row.talkType == 7">通知需要咨询的学员</span>
          </template>
        </el-table-column>
        <el-table-column prop="sourceNo" label="来源单号"></el-table-column>
        <el-table-column prop="createTime" label="生成时间"></el-table-column>
        <el-table-column prop="alertDetail" label="提醒内容"></el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChange"
          :current-page.sync="formInline.PageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts">
        </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Counts:0,
      value1:this.Global.querycensus(6),
      Message: '',
      drawer:false,
      formInline: {
        PageSize: '10',
        PageIndex: '1',
        UserInfo: '',
        SourceFlg: '',
        SourceNo: '',
        Content: '',
      },
      tableData: [],
      FourthSelection: [],
    }
  },
  beforeCreate() {
  },
  methods: {
    del(){
      this.$Http_Post('/sms/delete', {ids:this.FourthSelection}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.load()
        } else {
          this.Global.request_failure(res.Message)
        }
      })
    },
    onSubmit() {
      this.load();
    },
    handleFourthSelection(val) {
      var lsc = [];
      for (var i = 0; i < val.length; i++) {
        lsc.push(val[i].alertKey);
      }
      this.FourthSelection = lsc;
    },
    handleCurrentChange(val) {
      this.load(val);
    },
    load(){
      this.$Http_Post('/sms/getlist', {
        pageSize:this.formInline.PageSize,
        pageIndex:this.formInline.PageIndex,
        userInfo:this.formInline.UserInfo,
        sourceFlg:this.formInline.SourceFlg,
        sourceNo:this.formInline.SourceNo,
        content:this.formInline.Content,
        from:this.value1[0],
        to:this.value1[1],
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data
          this.Counts = res.Counts
        } else {
          this.Global.request_failure(res.Message)
        }
      })
    }
  },
  created() {
    this.load()
  },
}
</script>
<style>
.Interview_notice{height: 100%;}
.Interview_notice .demo-form-inline{background-color: #fff;padding: 10px;}
.Interview_notice .nav{margin-top: 14px;height: calc(100% - 100px);background-color: #fff;}
</style>
